module.exports = __webpack_public_path__ + "img/logo-tm.9ce31c96.png";